package com.downdogapp.client

import com.downdogapp.client.api.Manifest

lateinit var MANIFEST: Manifest

fun manifestInitialized() = ::MANIFEST.isInitialized
